import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/notifications`;

class NotificationServices {
  async getNotificationList(page, limit, filter, status) {
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });
      if (filter) params.set("filter", filter);
      if (status) params.set("status", status);
      const response = await requestToken.get(
        `${API_ROUTE}/get-notification-list?${params.toString()}`,
      );
      return response;
    } catch (error) {
      console.error("Error in getNotificationList:", error);
      throw error;
    }
  }

  async getUnreadCount() {
    try {
      const response = await requestToken.get(`${API_ROUTE}/unread-count`);
      return response;
    } catch (error) {
      console.error("Error in getUnreadCount:", error);
      throw error;
    }
  }

  async markAllRead() {
    try {
      const response = await requestToken.post(
        `${API_ROUTE}/mark-all-read`,
        {},
      );
      return response;
    } catch (error) {
      console.error("Error in markAllRead:", error);
      throw error;
    }
  }

  async markRead(id) {
    try {
      const response = await requestToken.post(
        `${API_ROUTE}/mark-read/${id}`,
        {},
      );
      return response;
    } catch (error) {
      console.error("Error in markRead:", error);
      throw error;
    }
  }
}

export default NotificationServices;